import { atom, AtomEffect } from "recoil";

import { FilterRule } from "../types/filter";

export const TIME_FILTER_STORAGE_KEY = "timeFilterVal";

// Custom sessionStorage effect that only persists the date range value
// This allows the dataIndex to change per table while keeping the date range
const timeFilterSessionStorageEffect: AtomEffect<FilterRule | null> = ({ onSet }) => {
    // On change, save only the value to sessionStorage
    onSet((newValue, _, isReset) => {
        if (isReset || !newValue) {
            removePersistedTimeFilterValue();
        } else {
            // Safely validate and store the value
            if (typeof newValue.value === "string") {
                setPersistedTimeFilterValue(newValue.value);
            } else {
                console.error("TimeFilter: Expected string value for time filter, got:", typeof newValue.value);
            }
        }
    });
};

export const timeFilterAtom = atom<FilterRule | null>({
    key: "timeFilterAtom",
    default: null,
    effects: [timeFilterSessionStorageEffect],
});

// Helper to get the persisted value from sessionStorage
export const getPersistedTimeFilterValue = (): string | null => {
    return sessionStorage.getItem(TIME_FILTER_STORAGE_KEY);
};

// Helper to set persisted value to sessionStorage
export const setPersistedTimeFilterValue = (value: string): void => {
    sessionStorage.setItem(TIME_FILTER_STORAGE_KEY, value);
};

// Helper to remove the persisted value from sessionStorage
export const removePersistedTimeFilterValue = (): void => {
    sessionStorage.removeItem(TIME_FILTER_STORAGE_KEY);
};
